import Loadable from '@loadable/component';
import GlobalContextProvider from '@/contexts/GlobalContext';
import LDProvider from '@/core/LaunchDarkly/LDProvider';
import '@wlloyalty/ui/dist/stylesheet.css';

const App = Loadable(() => import('./App'));

function Index() {
  return (
    <LDProvider>
      <GlobalContextProvider>
        <App />
      </GlobalContextProvider>
    </LDProvider>
  );
}

export default Index;
